@let referentiel = this.referentiel();

@if (referentiel) {
  <div class="flex h-full flex-col">
    <div class="p-lg border-neutral-light flex items-center justify-between border-b bg-white">
      <span class="title-medium-semibold">Général</span>
      @if (estVerrouille()) {
        <app-chip label="Verrouillé" variant="warning" />
      }
    </div>
    <section class="m-lg overflow-y-auto bg-white" hlmCard>
      <div class="flex pb-[90px]" hlmCardContent>
        <div class="form-group mb-2 flex-5">
          <h2 class="paragraph-large-semibold text-grey-10 mb-sm">Définir la vision du métier</h2>
          @if (peutModifier()) {
            <label>
              Diagnostic
              @if (form.enabled) {
                (veuillez choisir un fichier)
              }
            </label>
            <file-upload
              #fileUpload
              [accept]="'application/pdf'"
              [canChange]="peutModifier()"
              [href]="diagnosticReadUrl()"
              (file-change)="uploadDiagnostic($event)"
            />
            <span class="paragraph-medium-medium">Format accepté : PDF</span>
          } @else if (!diagnosticReadUrl()) {
            <app-empty-state title="Pas de diagnostic ajouté">
              <span class="text-content-secondary text-center"
                >Le référentiel est verrouillé, vous ne pouvez donc pas ajouter de diagnostic.</span
              >
            </app-empty-state>
          } @else {
            <div class="px-md py-sm bg-background-underground border-stroke-neutral-light rounded-md border">
              Nom Fichier
            </div>
          }
        </div>
        <div class="flex flex-1 justify-evenly">
          <div class="border-grey-2 h-full border-r"></div>
        </div>
        <form class="flex-6" [formGroup]="form">
          <h2 class="paragraph-large-semibold text-grey-10 mb-sm">Personas de fin de parcours</h2>
          <app-list-item formArrayName="fins" gap="24px">
            @if (fins.controls.length < 1 && !peutModifier()) {
              <app-empty-state title="Pas de personae ajoutés">
                <span class="text-content-secondary text-center"
                  >Le référentiel est verrouillé, vous ne pouvez donc pas ajouter de nouveaux personae.</span
                >
              </app-empty-state>
            } @else {
              @for (finControl of fins.controls; track $index; let idx = $index; let isFirst = $first) {
                @let fin = finControl.value;
                <app-expansion-panel
                  [titre]="fin.nom"
                  [formGroupName]="idx"
                  [isOpen]="isFirst"
                  [item]="idx"
                  [actions]="action"
                >
                  <div class="p-sm gap-md flex flex-col">
                    <hlm-field class="my-0!">
                      <label class="form-label" [for]="'input-nom-' + idx" hlmLabel>Titre</label>
                      <input
                        [id]="'input-nom-' + idx"
                        hlmInput
                        type="text"
                        placeholder="Titre"
                        formControlName="nom"
                        maxlength="30"
                      />
                      <hlm-field-description>30 caractères maximum.</hlm-field-description>
                    </hlm-field>
                    <hlm-field class="my-0!">
                      <label class="form-label" [for]="'textarea-description-' + idx" hlmLabel>Description</label>
                      <textarea
                        class="min-h-[170px]"
                        [id]="'textarea-description-' + idx"
                        hlmInput
                        placeholder="Description"
                        formControlName="description"
                      ></textarea>
                    </hlm-field>
                  </div>
                </app-expansion-panel>
              }

              @if (peutModifier()) {
                <button (click)="ajoutNouvelleFin()" hlmBtn variant="zone" size="large" type="button">
                  <ng-icon name="lucidePlus" />
                  <span class="paragraph-medium-medium">Ajouter un nouveau persona de fin de parcours</span>
                </button>
              }
            }
          </app-list-item>
        </form>
      </div>
    </section>
  </div>
}
